import how_it_works_1 from './how_it_works_1.webp';
import how_it_works_1_mobile from './how_it_works_1_mobile.webp';
import how_it_works_2 from './how_it_works_2.webp';
import how_it_works_2_mobile from './how_it_works_2_mobile.webp';
import how_it_works_3 from './how_it_works_3.webp';
import how_it_works_3_mobile from './how_it_works_3_mobile.webp';

export const howItWorks = {
  how_it_works_1: how_it_works_1.src,
  how_it_works_1_mobile: how_it_works_1_mobile.src,
  how_it_works_2: how_it_works_2.src,
  how_it_works_2_mobile: how_it_works_2_mobile.src,
  how_it_works_3: how_it_works_3.src,
  how_it_works_3_mobile: how_it_works_3_mobile.src,
};
